import styled from 'styled-components';
export const LangDrawerContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 24px 56px 56px;

  .drawer-lang_description {
    font-size: var(--font-size-sm);
  }

  .drawer-lang_body {
    flex-grow: 1;
    display: flex;
    margin-top: 32px;
    flex-direction: column;

    .drawer-lang_radio {
      margin-bottom: 24px;

      &.checked {
        font-weight: var(--font-weight-semibold);
      }

      label {
        display: flex;
        cursor: pointer;
        align-items: center;

        input[type='radio'] {
          margin-right: 12px;
        }
      }
    }
  }

  .drawer-lang_footer {
    gap: 24px;
    display: flex;
    padding: 16px 20px;
    align-items: center;
    background-color: var(--color-feedback-warning-100);

    img {
      width: 24px;
      height: 24px;
      padding: 8px;
      border-radius: var(--border-radius-circular);
      background-color: var(--color-feedback-warning-400);
    }

    div {
      gap: 8px;
      display: flex;
      flex-direction: column;

      p {
        margin: 0;
        font-size: var(--font-size-sm);
      }

      p.drawer-lang_footer-title {
        font-size: var(--font-size-default);
        font-weight: var(--font-weight-semibold);
      }
    }
  }
`;
//# sourceMappingURL=style.js.map